import { SvgIcon, SvgIconProps } from '@mui/material'

const CheckedBaggage = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2"></path>
            <path d="M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14"></path>
            <path d="M10 20h4"></path>
            <circle cx="16" cy="20" r="2"></circle>
            <circle cx="8" cy="20" r="2"></circle>
        </svg>
    </SvgIcon>
)

export default CheckedBaggage
